<div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">

  <!-- Título -->
  <div class="bg-light pt-3 pr-4 pb-3 pl-4">
    <div class="titulo_texto">Análise de Margem de Produtos</div>
  </div>

  <div class="pt-3 pr-4 pb-4 pl-4">

    <!-- Bloco de Filtros -->
    <div class="card mb-3">
      <div class="card-header bg-light py-2">
        <b>Filtros</b>
      </div>
      <div class="card-body py-3" [formGroup]="formFiltro">

        <!-- Indicador de carregamento de filtros -->
        @if (carregandoFiltros) {
          <div class="text-muted small mb-2">
            <i class="fa fa-spinner fa-spin"></i>&nbsp;Carregando opções de filtro...
          </div>
        }

        <div class="form-row align-items-end mb-2">
          <div class="form-group col-sm-2 mb-0">
            <label class="text-secondary"><b>Filtrar por:</b></label>
            <select class="form-control form-control-sm" formControlName="filtro"
              (change)="alterarFiltro($event.target.value)">
              @for (f of filtroProdutosDisponiveis; track f) {
                <option [value]="f.valor">{{ f.texto }}</option>
              }
            </select>
          </div>

          <div class="form-group col-sm-5 mb-0">
            <label class="text-secondary"><b>Valor:</b></label>

            <!-- Texto: código e descrição -->
            @if (ffp.filtro.value !== 'marca' && ffp.filtro.value !== 'subgrupo1' && ffp.filtro.value !== 'subgrupo2' && ffp.filtro.value !== 'subgrupo3' && ffp.filtro.value !== 'subgrupo4' && ffp.filtro.value !== 'subgrupo5') {
              <input
                class="form-control form-control-sm"
                type="text"
                formControlName="valor"
                placeholder="Digite o valor"
                (keyup.enter)="adicionarFiltro()" />
            }

            <!-- Select: Marca -->
            @if (ffp.filtro.value === 'marca') {
              <select
                class="form-control form-control-sm"
                formControlName="valor">
                <option value="">-- Selecione uma marca --</option>
                @for (marca of marcasDisponiveis; track marca) {
                  <option [value]="marca">{{ marca }}</option>
                }
              </select>
            }

            <!-- Select: Subgrupo 1 -->
            @if (ffp.filtro.value === 'subgrupo1') {
              <select
                class="form-control form-control-sm"
                formControlName="valor">
                <option value="">-- Selecione um subgrupo 1 --</option>
                @for (sg of subgrupos1Disponiveis; track sg) {
                  <option [value]="sg">{{ sg }}</option>
                }
              </select>
            }

            <!-- Select: Subgrupo 2 -->
            @if (ffp.filtro.value === 'subgrupo2') {
              <select
                class="form-control form-control-sm"
                formControlName="valor">
                <option value="">-- Selecione um subgrupo 2 --</option>
                @for (sg of subgrupos2Disponiveis; track sg) {
                  <option [value]="sg">{{ sg }}</option>
                }
              </select>
            }

            <!-- Select: Subgrupo 3 -->
            @if (ffp.filtro.value === 'subgrupo3') {
              <select
                class="form-control form-control-sm"
                formControlName="valor">
                <option value="">-- Selecione um subgrupo 3 --</option>
                @for (sg of subgrupos3Disponiveis; track sg) {
                  <option [value]="sg">{{ sg }}</option>
                }
              </select>
            }

            <!-- Select: Subgrupo 4 -->
            @if (ffp.filtro.value === 'subgrupo4') {
              <select
                class="form-control form-control-sm"
                formControlName="valor">
                <option value="">-- Selecione um subgrupo 4 --</option>
                @for (sg of subgrupos4Disponiveis; track sg) {
                  <option [value]="sg">{{ sg }}</option>
                }
              </select>
            }

            <!-- Select: Subgrupo 5 -->
            @if (ffp.filtro.value === 'subgrupo5') {
              <select
                class="form-control form-control-sm"
                formControlName="valor">
                <option value="">-- Selecione um subgrupo 5 --</option>
                @for (sg of subgrupos5Disponiveis; track sg) {
                  <option [value]="sg">{{ sg }}</option>
                }
              </select>
            }
          </div>

          <div class="form-group col-sm-5 mb-0">
            <button class="btn btn-sm btn-info mr-2" type="button" (click)="adicionarFiltro()">
              + Adicionar Filtro
            </button>
            <button class="btn btn-sm btn-success mr-2" type="button" (click)="buscar()"
              [disabled]="filtrosAtivos.length === 0 || carregando">
              <i class="fa fa-search"></i>&nbsp;Buscar
            </button>
            @if (filtrosAtivos.length > 0 || buscaRealizada) {
              <button class="btn btn-sm btn-secondary" type="button" (click)="limpar()"
                >
                Limpar
              </button>
            }
          </div>
        </div>

        <!-- Aviso sem filtros -->
        @if (filtrosAtivos.length === 0 && !buscaRealizada) {
          <div class="text-muted small mt-1">
            <i class="fa fa-info-circle"></i>&nbsp;Informe ao menos um filtro para pesquisar.
          </div>
        }

        <!-- Badges filtros ativos -->
        @if (filtrosAtivos.length > 0) {
          <div class="d-flex flex-wrap mt-2">
            @for (filtro of filtrosAtivos; track filtro; let i = $index) {
              <span class="badge badge-secondary mr-2 mb-1 px-2 py-1"
                style="font-size: 0.85rem; font-weight: normal; cursor: default;">
                {{ filtro.texto }}: {{ filtro.valor }}
                <span class="ml-1" style="cursor: pointer;" (click)="removerFiltro(i)">&times;</span>
              </span>
            }
          </div>
        }
      </div>
    </div>

    <!-- Loading -->
    @if (carregando) {
      <div class="text-center my-4">
        <i class="fa fa-spinner fa-spin fa-2x text-secondary"></i>
      </div>
    }

    <!-- Empty: antes de buscar -->
    @if (!carregando && !buscaRealizada) {
      <div class="text-center text-muted my-4">
        <i class="fa fa-search fa-2x mb-2 d-block"></i>
        <p class="mb-0">Use os filtros para pesquisar produtos.</p>
      </div>
    }

    <!-- Empty: sem resultados -->
    @if (!carregando && buscaRealizada && produtos.length === 0) {
      <div class="text-center text-muted my-4">
        <i class="fa fa-inbox fa-2x mb-2 d-block"></i>
        <p class="mb-0">Nenhum produto encontrado para os filtros informados.</p>
      </div>
    }

    <!-- Resultados -->
    @if (!carregando && produtos.length > 0) {
      <!-- Totalizador -->
      <div class="d-flex justify-content-between align-items-center mb-2">
        <span class="text-secondary small">
          <b>{{ totalProdutos }}</b> produto(s) encontrado(s) — Página {{ paginaAtual + 1 }} de {{ totalPaginas }}
        </span>
      </div>
      <!-- TABELA DESKTOP -->
      <div class="table-responsive d-none d-md-block">
        <table class="table table-sm table-hover">
          <thead>
            <tr>
              <th class="tabela_borda"></th>
              <th class="tabela_borda">Código</th>
              <th class="tabela_borda">Descrição</th>
              <th class="text-right tabela_borda">Estoque</th>
              @for (local of locaisOrdenados; track local) {
                <th class="text-right tabela_borda">{{ local }}</th>
              }
              <th class="text-right tabela_borda">Custo (R$)</th>
              <th class="text-right tabela_borda">Preço Tabela (R$)</th>
            </tr>
          </thead>
          <tbody>
            @for (p of produtos; track trackById($index, p)) {
              <tr
                [ngClass]="{ 'table-success': estaSelecionado(p.id) }">
                <td class="tabela_borda text-center tabela_acao">
                  <i class="fa  btn_tabela_acao" [ngClass]="estaSelecionado(p.id) ? 'fa-check-square-o' : 'fa-square-o'"
                  (click)="toggleSelecionado(p)"></i>
                </td>
                <td class="tabela_borda">{{ p.codigo }}</td>
                <td class="tabela_borda">{{ p.name }}</td>
                <td class="text-right tabela_borda">{{ p.estoque | number:'1.0-2' }}</td>
                @for (local of locaisOrdenados; track local) {
                  <td class="text-right tabela_borda">{{ getEstoqueLocal(p.id, local) | number:'1.0-2' }}</td>
                }
                <td class="text-right tabela_borda">{{ p.custo | currency:'BRL' }}</td>
                <td class="text-right tabela_borda">{{ p.price | currency:'BRL' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <!-- CARDS MOBILE -->
      <div class="d-md-none">
        @for (p of produtos; track trackById($index, p)) {
          <div class="card mb-2"
            [ngClass]="{ 'border-success': estaSelecionado(p.id) }">
            <div class="card-body py-2 px-3">
              <div class="d-flex justify-content-between align-items-start mb-1">
                <div>
                  <div class="text-secondary small">{{ p.codigo }}</div>
                  <div class="font-weight-bold">{{ p.name }}</div>
                </div>
                <button class="btn btn-sm" [ngClass]="estaSelecionado(p.id) ? 'btn-success' : 'btn-outline-secondary'"
                  type="button" (click)="toggleSelecionado(p)">
                  <i class="fa " [ngClass]="estaSelecionado(p.id) ? 'fa-check-square-o' : 'fa-square-o'"></i>
                </button>
              </div>
              <div class="row no-gutters small">
                <div class="col-6 mb-1">
                  <span class="text-secondary">Estoque:</span> {{ p.estoque | number:'1.0-2' }}
                </div>
                <div class="col-6 mb-1">
                  <span class="text-secondary">Custo:</span> {{ p.custo | currency:'BRL' }}
                </div>
                <div class="col-12 mb-1">
                  <span class="text-secondary">Preço Tabela:</span> {{ p.price | currency:'BRL' }}
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <!-- Paginação -->
      <app-pagination
        [page]="paginaAtual + 1"
        [totalPages]="totalPaginas"
        [totalItems]="totalProdutos"
        [pageSize]="pageSize"
        [pageSizes]="[20, 50, 100]"
        (pageChange)="mudarPagina($event)"
        (pageSizeChange)="mudarPageSize($event)">
      </app-pagination>
    }

    <!-- Produtos Selecionados -->
    @if (produtosSelecionados.length > 0) {
      <div class="card mt-3">
        <div class="card-header bg-light py-2 d-flex justify-content-between align-items-center">
          <b>Produtos Selecionados ({{ produtosSelecionados.length }})</b>
          <button class="btn btn-sm btn-outline-danger" type="button" (click)="produtosSelecionados = []">
            Limpar Seleção
          </button>
        </div>
        <div class="card-body py-3">
          <!-- Régua Média -->
          <div class="mb-3">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-secondary small"><b>Margem Média dos Selecionados:</b></span>
              @if (margemMedia !== null) {
                <span class="font-weight-bold">{{ margemMedia | number:'1.1-1' }}%</span>
              }
              @if (margemMedia === null) {
                <span class="text-muted small">Informe custo e preço para calcular</span>
              }
            </div>
            <app-margem-regua class="w-100" [margem]="margemMedia"></app-margem-regua>
          </div>
          <!-- Tabela Desktop -->
          <div class="table-responsive d-none d-md-block">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th class="tabela_borda"></th>
                  <th class="tabela_borda">Código</th>
                  <th class="tabela_borda">Descrição</th>
                  <th class="text-right tabela_borda">Estoque</th>
                  @for (local of locaisOrdenados; track local) {
                    <th class="text-right tabela_borda">{{ local }}</th>
                  }
                  <th class="text-right tabela_borda">Custo (R$)</th>
                  <th class="tabela_borda" style="min-width:130px">Preço Tabela (R$)</th>
                  <th class="text-right tabela_borda">Margem (%)</th>
                </tr>
              </thead>
              <tbody>
                @for (ps of produtosSelecionados; track ps; let i = $index) {
                  <tr>
                    <td class="tabela_borda text-center tabela_acao">
                      <i class="fa fa-remove btn_tabela_acao" (click)="removerSelecionado(i)"></i>
                    </td>
                    <td class="tabela_borda">{{ ps.codigo }}</td>
                    <td class="tabela_borda">{{ ps.name }}</td>
                    <td class="text-right tabela_borda">{{ ps.estoque | number:'1.0-2' }}</td>
                    @for (local of locaisOrdenados; track local) {
                      <td class="text-right tabela_borda">{{ getEstoqueLocal(ps.id, local) | number:'1.0-2' }}</td>
                    }
                    <td class="text-right tabela_borda">{{ ps.custoEditavel | currency:'BRL' }}</td>
                    <td class="tabela_borda">
                      <input class="form-control form-control-sm text-right"
                        type="number" min="0" step="0.01"
                        [(ngModel)]="ps.precoEditavel"
                        [ngModelOptions]="{standalone: true}" />
                    </td>
                    <td class="text-right tabela_borda">
                      @if (calcularMargemSelecionado(ps) !== null) {
                        <span>
                          {{ calcularMargemSelecionado(ps) | number:'1.1-1' }}%
                        </span>
                      }
                      @if (calcularMargemSelecionado(ps) === null) {
                        <span class="text-muted">—</span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <!-- Cards Mobile -->
          <div class="d-md-none">
            @for (ps of produtosSelecionados; track ps; let i = $index) {
              <div class="card mb-2">
                <div class="card-body py-2 px-3">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <div>
                      <div class="text-secondary small">{{ ps.codigo }}</div>
                      <div class="font-weight-bold">{{ ps.name }}</div>
                    </div>
                    <i class="fa fa-remove btn_tabela_acao" (click)="removerSelecionado(i)"></i>
                  </div>
                  <div class="form-row small">
                    <div class="form-group col-6 mb-1">
                      <label class="text-secondary mb-0">Custo (R$):</label>
                      <div class="form-control form-control-sm bg-light">{{ ps.custoEditavel | currency:'BRL' }}</div>
                    </div>
                    <div class="form-group col-6 mb-1">
                      <label class="text-secondary mb-0">Preço Tabela (R$):</label>
                      <input class="form-control form-control-sm" type="number" min="0" step="0.01"
                        [(ngModel)]="ps.precoEditavel" [ngModelOptions]="{standalone: true}" />
                    </div>
                  </div>
                  <div class="small">
                    <span class="text-secondary">Estoque:</span> {{ ps.estoque | number:'1.0-2' }}
                    &nbsp;|&nbsp;
                    <span class="text-secondary">Margem:</span>
                    @if (calcularMargemSelecionado(ps) !== null) {
                      <span> {{ calcularMargemSelecionado(ps) | number:'1.1-1' }}%</span>
                    }
                    @if (calcularMargemSelecionado(ps) === null) {
                      <span class="text-muted"> —</span>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }

  </div>
</div>
